import React, { FC } from 'react';
import MuiButtonGroup, { ButtonGroupProps as MuiButtonGroupProps } from '@mui/material/ButtonGroup';
import { BpDesignSystem } from '../../types';
import { ButtonWithTooltip, ButtonWithTooltipProps } from './ButtonWithTooltip';

export interface GroupButtonConfig<T extends string>
  extends Omit<ButtonWithTooltipProps, 'onClick' | 'id' | 'slotProps'> {
  onClick: (id: T, event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  tooltipProps?: Exclude<ButtonWithTooltipProps['slotProps'], undefined>['tooltip'];
  id: T;
}

export type ButtonGroupProps = BpDesignSystem.PropsWithChildren<
  Omit<MuiButtonGroupProps, 'color'> & {
    color?: 'primary' | 'secondary' | 'default';
    items?: GroupButtonConfig<string>[]; // you can use children instead of items prop
  }
>;

export const ButtonGroup: FC<ButtonGroupProps> = ({
  dataTest,
  items,
  children,
  color = 'primary',
  variant = 'outlined',
  ...props
}) => {
  return (
    <MuiButtonGroup data-test={dataTest} color={color as 'primary'} variant={variant} {...props}>
      {items?.map(({ tooltipProps, children, onClick, ...buttonProps }) => (
        <ButtonWithTooltip
          key={buttonProps.id}
          {...buttonProps}
          slotProps={{ tooltip: tooltipProps }}
          onClick={(e) => onClick(buttonProps.id, e)}
        >
          {children}
        </ButtonWithTooltip>
      ))}
      {children}
    </MuiButtonGroup>
  );
};
